import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getListThuongHieuKhacPhucLoi } from '../../../redux/category/action';
import { toast } from 'react-toastify';

const HuongDanKhacPhucLoi = () => {
  const [selectedBrand, setSelectedBrand] = useState('');
  const [modelNumber, setModelNumber] = useState('');
  const history = useHistory();
  const dispatch = useDispatch();

  const listThuongHieu = useSelector((store) => store.categories.listThuongHieu);

  const handleSearch = () => {
    if (!selectedBrand) {
      toast.error('Vui lòng chọn thương hiệu.');
      return;
    }
    history.push(`/danh-muc-san-pham?brand=${selectedBrand}&model=${modelNumber}`);
  };

  useEffect(() => {
    dispatch(getListThuongHieuKhacPhucLoi());
  }, []);

  const steps = [
    {
      icon: (
        <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <rect x="2" y="3" width="20" height="14" rx="2" />
          <path d="M8 21h8M12 17v4" />
        </svg>
      ),
      step: 'BƯỚC 01',
      title: 'Chọn thương hiệu',
      desc: 'Chọn thương hiệu của thiết bị để chúng tôi hiển thị đúng hướng dẫn và thông tin phù hợp.',
    },
    {
      icon: (
        <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
          <rect x="9" y="3" width="6" height="4" rx="1" />
          <path d="M9 12h6M9 16h4" />
        </svg>
      ),
      step: 'BƯỚC 02',
      title: 'Nhập Model',
      desc: 'Nhập mã model hoặc số seri của thiết bị để tìm đúng sản phẩm cần hỗ trợ.',
    },
    {
      icon: (
        <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path d="M9 12l2 2 4-4" />
          <circle cx="12" cy="12" r="10" />
        </svg>
      ),
      step: 'BƯỚC 03',
      title: 'Xem hướng dẫn',
      desc: 'Xem các lỗi thường gặp và làm theo hướng dẫn từng bước để kiểm tra hoặc sửa thiết bị.',
    },
  ];

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif", background: '#f8f9fa' }}>
      {/* ── Hero ── */}
      <section
        style={{
          background: 'linear-gradient(135deg, #ffffff 0%, #f0f4ff 100%)',
          padding: '72px 16px 56px',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* dot grid decoration */}
        <div
          aria-hidden
          style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: 'radial-gradient(circle, #c7d4f0 1px, transparent 1px)',
            backgroundSize: '28px 28px',
            opacity: 0.45,
            pointerEvents: 'none',
          }}
        />

        <div style={{ position: 'relative', zIndex: 1, maxWidth: 700, margin: '0 auto' }}>
          <h1 style={{ fontSize: 'clamp(1.8rem,4vw,2.5rem)', fontWeight: 800, color: '#1a1a2e', lineHeight: 1.2 }}>
            Hướng dẫn <span style={{ color: '#2563eb' }}>khắc phục lỗi sản phẩm</span>
          </h1>
          <p style={{ color: '#555', fontSize: '1rem', margin: '16px 0 36px', lineHeight: 1.7 }}>Dễ dàng kiểm tra và khắc phục các lỗi thường gặp với hướng dẫn chi tiết từ GIGACARE cho các thiết bị được chứng nhận.</p>

          {/* Search card */}
          <div
            style={{
              background: '#fff',
              borderRadius: 16,
              boxShadow: '0 8px 32px rgba(37,99,235,0.10)',
              padding: '28px 24px',
              display: 'flex',
              flexWrap: 'wrap',
              gap: 12,
              alignItems: 'center',
              justifyContent: 'center',
              maxWidth: 700,
              margin: '0 auto',
            }}
          >
            {/* Brand select */}
            <div style={{ flex: '1 1 200px', minWidth: 160 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#888', marginBottom: 6, textAlign: 'left' }}>Chọn thương hiệu</label>
              <select
                value={selectedBrand}
                onChange={(e) => setSelectedBrand(e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  border: '1.5px solid #e2e8f0',
                  borderRadius: 10,
                  fontSize: 14,
                  color: '#333',
                  background: '#fafafa',
                  appearance: 'none',
                  cursor: 'pointer',
                }}
              >
                <option value="">-- Chọn thương hiệu --</option>
                {listThuongHieu.map((brand) => (
                  <option key={brand.THUONG_HIEU} value={brand.THUONG_HIEU}>
                    {brand.THUONG_HIEU}
                  </option>
                ))}
              </select>
            </div>

            {/* Model input */}
            <div style={{ flex: '2 1 240px', minWidth: 180 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#888', marginBottom: 6, textAlign: 'left' }}>Nhập Model hoặc Serial sản phẩm</label>
              <div style={{ position: 'relative' }}>
                <input
                  type="text"
                  placeholder="...."
                  value={modelNumber}
                  onChange={(e) => setModelNumber(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '10px 40px 10px 14px',
                    border: '1.5px solid #e2e8f0',
                    borderRadius: 10,
                    fontSize: 14,
                    color: '#333',
                    background: '#fafafa',
                    boxSizing: 'border-box',
                  }}
                />
                <svg width="16" height="16" fill="none" stroke="#aaa" strokeWidth="2" viewBox="0 0 24 24" style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)' }}>
                  <circle cx="11" cy="11" r="8" />
                  <path d="m21 21-4.35-4.35" />
                </svg>
              </div>
            </div>

            {/* CTA */}
            <div style={{ flex: '0 0 auto', alignSelf: 'flex-end' }}>
              <button
                style={{
                  background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 10,
                  padding: '11px 28px',
                  fontWeight: 700,
                  fontSize: 14,
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  boxShadow: '0 4px 14px rgba(37,99,235,0.35)',
                  transition: 'opacity .2s',
                }}
                onMouseOver={(e) => (e.currentTarget.style.opacity = '.85')}
                onMouseOut={(e) => (e.currentTarget.style.opacity = '1')}
                onClick={handleSearch}
              >
                Tìm giải pháp
              </button>
            </div>
          </div>
        </div>
      </section>

      <section style={{ maxWidth: 1100, margin: '0 auto', padding: '60px 20px' }}>
        <div style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 800, color: '#1a1a2e', marginBottom: 4 }}>Hướng dẫn tra cứu</h2>
          <div style={{ width: 48, height: 4, background: '#2563eb', borderRadius: 4 }} />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(260px,1fr))', gap: 24 }}>
          {steps.map((s, i) => (
            <div
              key={i}
              style={{
                background: '#fff',
                borderRadius: 16,
                padding: '28px 24px',
                boxShadow: '0 2px 16px rgba(0,0,0,0.06)',
                borderTop: '3px solid #2563eb',
                transition: 'transform .2s, box-shadow .2s',
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 28px rgba(37,99,235,0.12)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 16px rgba(0,0,0,0.06)';
              }}
            >
              <div
                style={{
                  width: 44,
                  height: 44,
                  background: 'linear-gradient(135deg,#2563eb,#1d4ed8)',
                  borderRadius: 10,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  marginBottom: 20,
                }}
              >
                {s.icon}
              </div>
              <p style={{ color: '#2563eb', fontWeight: 700, fontSize: 12, letterSpacing: 1, marginBottom: 6 }}>{s.step}</p>
              <h3 style={{ fontSize: '1rem', fontWeight: 700, color: '#1a1a2e', marginBottom: 10 }}>{s.title}</h3>
              <p style={{ color: '#666', fontSize: 14, lineHeight: 1.7, margin: 0 }}>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA banner ── */}
      <section
        style={{
          background: 'linear-gradient(135deg, #1e40af 0%, #2563eb 100%)',
          margin: '0 0 60px',
          padding: '56px 24px',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <div
          aria-hidden
          style={{
            position: 'absolute',
            right: -40,
            bottom: -40,
            width: 260,
            height: 260,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.07)',
          }}
        />
        <div
          aria-hidden
          style={{
            position: 'absolute',
            right: 80,
            top: -60,
            width: 180,
            height: 180,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.05)',
          }}
        />

        <div style={{ maxWidth: 680, position: 'relative', zIndex: 1 }}>
          <h2 style={{ color: '#fff', fontSize: '1.4rem', fontWeight: 800, marginBottom: 12 }}>Bạn vẫn gặp khó khăn?</h2>
          <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: 15, lineHeight: 1.7, marginBottom: 28 }}>Các chuyên gia kỹ thuật của chúng tôi sẵn sàng hỗ trợ 24/7 đối với các chẩn đoán phần cứng phức tạp và xử lý yêu cầu bảo hành.</p>
          <button
            style={{
              background: '#fff',
              color: '#2563eb',
              border: 'none',
              borderRadius: 10,
              padding: '12px 28px',
              fontWeight: 700,
              fontSize: 14,
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
            }}
          >
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            Chat với chúng tôi
          </button>
        </div>

        {/* headphone icon decoration */}
        <div
          style={{
            position: 'absolute',
            right: 80,
            top: '50%',
            transform: 'translateY(-50%)',
            opacity: 0.18,
          }}
          aria-hidden
        >
          <svg width="140" height="140" fill="white" viewBox="0 0 24 24">
            <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
            <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3z" />
            <path d="M3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
          </svg>
        </div>
      </section>
    </div>
  );
};

export default HuongDanKhacPhucLoi;
